import React from "react";
import { ConfigContext } from "../../config/configContext";
import { getResolvedTemplateConfig } from "../../config/resolvedTemplateConfig";
import Navbar from "../organisms/common/navbar";
import Footer from "../organisms/common/footer";

const generalLayoutConfig = getResolvedTemplateConfig();

const GeneralLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ConfigContext.Provider value={generalLayoutConfig}>
      <div className="min-h-screen flex flex-col bg-white text-[#0B1F16]">
        <Navbar />
        <main className="flex-1 w-full">{children}</main>
        <Footer />
      </div>
    </ConfigContext.Provider>
  );
};

export default GeneralLayout;